import { titleCase } from './SqliteHelp.js'
export function makePagesCode(dbName, tableNames, tableDatas) {
    tableNames = JSON.parse(JSON.stringify(tableNames));
    tableDatas = JSON.parse(JSON.stringify(tableDatas));
    return startCode + importCode(tableNames) + partCode + pagesCode(tableNames)
}

export const startCode = `/// Author: Samle
import 'package:get/get.dart';
`

export function importCode(tableNames) {
    let importCode_ = ""
    // 遍历导入
    tableNames.forEach((tableName) => {
        importCode_ = importCode_ + `
import '../modules/${tableName}/bindings/${tableName}_binding.dart';
import '../modules/${tableName}/views/${tableName}_view.dart';`
    });
    return importCode_
}

export const partCode = `

part 'app_routes.dart';
`


export function pagesCode(tableNames){
    let pagesCodeStart = `
class AppPages {
  AppPages._();
  static const INITIAL = Routes.${tableNames[0].toUpperCase()};
  static final routes = [
`
    tableNames.forEach((tableName) => {
        pagesCodeStart = pagesCodeStart + `    GetPage(
      name: _Paths.${tableName.toUpperCase()},
      page: () => ${titleCase(tableName)}View(),
      binding: ${titleCase(tableName)}Binding(),
    ),`
    });
    
    return pagesCodeStart + `
  ];
}
`
}